
import CommonRoutes from './commonRoutes';
import CandidateRoute from './candidateRoutes';
import EmployeeRoutes from './employeeRoutes';
import RecruiterRoutes from './recruiterRoutes'
import AdminRoutes from './adminRoutes';
import AccountantRoutes from './accountantRoutes';
import HRRoutes from './hrRoutes';
import PlatformRoutes from './platformRoutes';
import NotFound from '../NotFound';
import { Route, Navigate } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import ProtectedRoute from '../auth/ProtectedRoute';
import Loader from '../components/Loader';

// Shared pages (accessible by all authenticated roles)
const Procurement = lazy(() => import('../pages/Procurement/Procurement'));
const Feed = lazy(() => import('../pages/Feed'));
// Attendance workspace is one shared, role-aware route (tabs adapt per role).
// Must be a single shared route — not per-role — so React Router doesn't match a
// different role's /attendance first and fail the role guard.
const AttendanceWorkspace = lazy(() => import('../pages/Attendance/AttendanceWorkspace'));
const NotificationsPage = lazy(() => import('../pages/Notifications/NotificationsPage'));

const Home = lazy(() => import('../pages/Home'));

const allRoutes = (
  <>
    <Route path="/" element={
      <Suspense fallback={<Loader />}>
        <Home />
      </Suspense>
    } />
    {CommonRoutes}
    {CandidateRoute}

    {/* Shared routes — accessible by all authenticated roles */}
    <Route
      path="/v1/procurement-management/procurement"
      element={
        <Suspense fallback={<Loader />}>
          <ProtectedRoute element={<Procurement />} allowedRoles={['Admin', 'HR', 'Employee', 'Recruiter', 'Accountant']} />
        </Suspense>
      }
    />
    <Route
      path="/v1/feed"
      element={
        <Suspense fallback={<Loader />}>
          <ProtectedRoute element={<Feed />} allowedRoles={['Admin', 'HR', 'Employee', 'Recruiter', 'Accountant']} />
        </Suspense>
      }
    />
    <Route
      path="/attendance"
      element={
        <Suspense fallback={<Loader />}>
          <ProtectedRoute element={<AttendanceWorkspace />} allowedRoles={['Admin', 'HR', 'Employee', 'Accountant']} />
        </Suspense>
      }
    />
    <Route
      path="/notifications"
      element={
        <Suspense fallback={<Loader />}>
          <ProtectedRoute element={<NotificationsPage />} allowedRoles={['Admin', 'HR', 'Employee', 'Recruiter', 'Accountant']} />
        </Suspense>
      }
    />

    {AdminRoutes}
    {HRRoutes}
    {AccountantRoutes}
    {RecruiterRoutes}
    {EmployeeRoutes}
    {PlatformRoutes}
    <Route path="*" element={<NotFound />} />
  </>
);


export default allRoutes;
